<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love</span></p>
<p class="p1"><span class="t1"><img alt="img1.jpg" src="Images/img1.jpg"/></span></p>
<p class="p2"><span class="t2">A Night Owl Reviews Top Pick!</span></p>
<p class="p3">“If you like fantasy and urban fantasy (of which this book seems to be a mix), then I would highly recommend that you read this book. There is enough in Dreamlands to satisfy those with a taste for gentle romance, for action sequences, for character driven stories and also (as a brief warning) mindless violence, especially towards the end of the book.”</p>
<p class="p4">—Reviews by Jessewave</p>
<p class="p5">“This debut novel from a new author is a stunning piece of work. Intricately plotted with fascinating world building and creative characters, this story captures interest immediately and carries it through to the end.”</p>
<p class="p6">—Rainbow Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?4d637b98